export enum InventoryStatusEnum {
    COMPLIANT = 'Conforme',
    GAP = 'Ecart',
}
